var sika = sika || {};
( function () {
    sika.ecom = {
        init: function () {
            sika.ecom.bindEvents();
            if ( jQuery( '.js-sika-product-variants' ).length === 1 ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    var interval = setInterval(function() {
                        if (window.Handlebars) {
                            clearInterval(interval);
                            e4.handlebars.registerHelpers( 'compare' );
                            sika.ecom.handlebars.registerHelpers();
                            e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-sika-product-variants-options #js-e-handlebars-tmpl-sika-variant-matrix #js-e-handlebars-tmpl-sika-product-variant-image-list-download-image #js-e-handlebars-tmpl-sika-product-variant-image-list-client-logo #js-e-handlebars-tmpl-sika-product-variant-image-list-download #js-e-handlebars-tmpl-sika-b2b-top-price #js-e-handlebars-tmpl-sika-image-carousel #js-e-handlebars-tmpl-sika-image-carousel-modal' );
                            sika.ecom.variants.init();
                            sika.ecom.carousel.init();
                        }
                    }, 100);
                    
                } );
            }
            else {
                sika.ecom.setVariantColor();
            }
        },
        bindEvents: function () {
            jQuery( '.js-toggle-download-product-images' ).on( 'click', function ( event ) {
                if ( jQuery( '.js-sika-product-image-download' ).find( 'li' ).length > 1 ) {
                    event.preventDefault();
                    jQuery( '.js-sika-product-image-download' ).slideToggle( 'fast' );
                }

            } ).find( 'a' ).on( 'click', function () {
                jQuery( '.js-sika-product-image-download' ).slideUp( 'fast' );
            } );

            jQuery( '.js-e-productlist' ).on( 'mouseenter', '.js-e-products-item-image[data-image-hover]', function ( event ) {
                var jImage = jQuery( event.target ),
                    strHoverSrc = jImage.data( 'image-hover' );
                jImage.attr( 'data-image-base', event.target.src ).attr( 'src', strHoverSrc );
            } ).on( 'mouseleave', '.js-e-products-item-image[data-image-hover]', function ( event ) {
                var jImage = jQuery( event.target ),
                    strBaseSrc = jImage.data( 'image-base' );
                jImage.attr( 'src', strBaseSrc );
            } );

            jQuery( document ).on( 'show.bs.modal', '.js-e-product-image-modal', function () {
                jQuery( '.js-e-header' ).css( 'z-index', 1 );
            } ).on( 'hide.bs.modal', '.js-e-product-image-modal', function () {
                jQuery( '.js-e-header' ).css( 'z-index', 1030 );
            } );
        },
        handlebars: {
            registerHelpers: function () {
                Handlebars.registerHelper( 'tolower', function ( str ) {
                    if ( str ) {
                        return str.toLowerCase();
                    }

                } );
                Handlebars.registerHelper( 'counter', function ( index ) {
                    return index + 1;

                } );
                Handlebars.registerHelper( 'b2cIsOptInCompAndAllowed', function ( opt, options ) {
                    var isInComp = sika.ecom.variants.data.variantcombinations.filter( function ( obj ) {
                        if ( obj.variantID.indexOf( opt ) > -1 && obj.webshop.indexOf( 'sikabubble.dk' ) > -1 ) {
                            return obj;
                        }
                    } ).length > 0;
                    return isInComp ? options.fn( this ) : options.inverse( this );

                } );
                Handlebars.registerHelper( 'counter_extended', function ( index1, index2, index3, index4 ) {
                    index1 === undefined ? 0 : index1;
                    index2 === undefined ? 0 : index2;
                    index3 === undefined ? 0 : index3;
                    index4 === undefined ? 0 : index4;
                    return index1 + index2 + index3 + index4;
                } );
                Handlebars.registerHelper( 'isPrimaryPositionFirst', function ( detailImages, options ) {
                    var isPrimaryFirst = true;
                    if ( detailImages.length > 0 ) {
                        var tempImg = detailImages[0].original.replace( '/Files/Images/ecom/Products/', '' ).replace( '.jpg', '' );
                        if(tempImg.endsWith('_1')){
                            isPrimaryFirst = false;
                        }
                    }
                    return isPrimaryFirst ? options.fn( this ) : options.inverse( this );
                } );
            }
        },
        testAssortment: function ( fnCallback ) {
            jQuery.ajax( {
                url: e4.settings.ecom.filters.url,
                data: {
                    Assortment: 'JA'
                }
            } ).done( function ( data ) {
                var colors = sika.ecom.variants.data.variantoptions.Color;
                //console.log(data);
                for ( var i = 0; i < colors.length; i++ ) {
                    for ( var j = 0; j < data.products.length; j++ ) {
                        ( function ( c ) {
                            if ( data.products[ j ].productVariantId === colors[ c ].id ) {
                                colors[ c ].isAllowed = true;
                            }
                        } )( i );
                    }
                }

                if ( typeof fnCallback === 'function' ) {
                    fnCallback( sika.ecom.variants.data );
                }
            } );
        },
        carousel: {
            _cache: {},
            init: function () {
                sika.ecom.carousel.bindEvents();
                sika.ecom.carousel.getData();
                sika.ecom.carousel.zoom.init();
            },
            bindEvents: function () {
                jQuery( '.js-e-product' ).on( 'slide.bs.carousel', '#js-e-product-image-carousel', function ( event ) {
                   //console.log( event.relatedTarget );
                    if ( jQuery( event.relatedTarget ).is( '.is-orbitour' ) === true ) {
                        jQuery( '.product-image-zoom-help-text' ).hide();
                    }
                    else {
                        jQuery( '.product-image-zoom-help-text' ).show();
                    }
                } )
            },
            getData: function ( strColorCode ) {
                if ( jQuery( '#js-e-product-image-carousel-container' ).length === 1 ) {
                    sika.ecom.carousel.getImageData().done( function ( jsonData ) {
                        sika.ecom.carousel.build( jsonData, strColorCode );
                        jsonData.images.forEach( function ( imageObj ) {
                            jQuery( '.js-sika-productsheet-generate-variant-image[data-variant="' + imageObj.variantId + '"]' ).data( 'image', imageObj.primary.original );
                        } )

                    } );
                    sika.ecom.carousel.event = e4.util.registerEvents( 'loaded', 'carousel' );
                }
            },
            getOrbitourData: function ( jsonData ) {
                var xhr = null;

                if ( sika.ecom.carousel._cache[ 'orbitourData_' + jsonData.colorCode ] !== undefined ) {
                    xhr = sika.ecom.carousel._cache[ 'orbitourData_' + jsonData.colorCode ];
                }
                else {
                    xhr = jQuery.ajax( {
                        url: '/system/data/orbitour-api',
                        data: {
                            search_sku: jsonData.productNumber + '_' + jsonData.colorCode
                        }
                    } );
                    sika.ecom.carousel._cache[ 'orbitourData_' + jsonData.colorCode ] = xhr;
                }

                return xhr;
            },
            getImageData: function () {
                var productId = jQuery( '.js-e-product' ).data( 'id' ),
                    xhr = null;

                if ( sika.ecom.carousel._cache[ 'imageData_' + productId ] !== undefined ) {
                    xhr = sika.ecom.carousel._cache[ 'imageData_' + productId ];
                }
                else {
                    xhr = jQuery.ajax( {
                        url: '/system/data/productimage',
                        data: {
                            productid: productId
                        }
                    } );
                    sika.ecom.carousel._cache[ 'imageData_' + productId ] = xhr;
                }

                return xhr;
            },
            handleOrbitourData: function ( orbitourJson, objImageData ) {
                var productNumber = objImageData.productNumber,
                    colorCode = objImageData.colorCode,
                    returnValue = orbitourJson.results.filter( function ( obj ) {
                        return obj.sku === productNumber + '_' + colorCode;
                    } );

                if ( returnValue.length > 0 ) {
                    return returnValue;
                }
                else {
                    return '';
                }

            },
            mapImageData: function ( jsonData, requestedColorCode ) {
                var objImageData = jsonData.images[ 0 ],
                    hashColorCode = '';
                if ( location.hash.length > 0 ) {
                    hashColorCode = location.hash.replace( '#', '' );
                }
                if ( requestedColorCode !== undefined ) {
                    var filteredImageDataByRequest = jsonData.images.filter( function ( objImage ) {
                        return objImage.colorCode === requestedColorCode;
                    } );
                    if ( filteredImageDataByRequest.length === 1 ) {
                        objImageData = filteredImageDataByRequest[ 0 ];
                    }
                }
                else if ( hashColorCode !== '' ) {
                    var filteredImageDataByHash = jsonData.images.filter( function ( objImage ) {
                        return objImage.colorCode.toString() === hashColorCode.toString();
                    } );
                    if ( filteredImageDataByHash.length === 1 ) {
                        objImageData = filteredImageDataByHash[ 0 ];
                    }
                }
                return objImageData;
            },
            build: function ( jsonData, requestedColorCode ) {
                var objImageData = sika.ecom.carousel.mapImageData( jsonData, requestedColorCode );
                sika.ecom.carousel.getOrbitourData( objImageData ).done( function ( orbitourJson ) {

                    if ( orbitourJson.count > 0 ) {
                        var primaryResult = orbitourJson.results.filter( function ( obj ) {
                            return obj.sku === objImageData.productNumber + '_' + objImageData.colorCode;
                        } );

                        if ( primaryResult.length === 1 ) {
                            objImageData.orbitour = {
                                thumb: primaryResult[ 0 ].thumbnail_url,
                                iframe: primaryResult[ 0 ].presentationcontent_set[ 0 ].iframe_url,
                                id: primaryResult[ 0 ].uid
                            };
                        }
                    }

                    if ( objImageData.details.length > 0 ) {
                        jQuery( '.js-toggle-download-product-images' ).attr( 'href', '/system/data/download-zip?productNumber=' + objImageData.productNumber + '&colorCode=' + objImageData.colorCode + '&download=true' );
                    }
                    jQuery( '#js-e-product-image-carousel-container' ).html( e4.handlebars.tmpl.sikaImageCarousel( objImageData ) );
                    jQuery( '#js-e-product-image-carousel-modal-container' ).html( e4.handlebars.tmpl.sikaImageCarouselModal( objImageData ) );
                } );
            },
            zoom: {
                defaults: {
                    zoomLevel: 2,
                    zoomStep: 0.1,
                    maxZoomLevel: 2,
                    minZoomLevel: 1
                },
                zoomed: false,
                reference: null,
                init: function () {
                    sika.ecom.carousel.zoom.bindEvents();
                },
                bindEvents: function () {
                    jQuery( '.js-e-product-images-zoom-container' ).on( 'click', '.js-product-image-zoom, .js-product-image-zoom-by-side-container', function ( event ) {
                        if ( jQuery( event.target ).is( '.js-product-image-modal-trigger' ) === false ) {

                            if ( sika.ecom.carousel.zoom.zoomed === true ) {
                                sika.ecom.carousel.zoom.style.reset( event.target );
                            }
                            else {
                                sika.ecom.carousel.zoom.zoomed = true;
                                sika.ecom.carousel.zoom.style.set( event.currentTarget, event );
                            }
                        }
                    } ).on( 'mousemove', '.js-product-image-zoom-by-side-container', function ( event ) {
                        sika.ecom.carousel.zoom.style.set( event.currentTarget, event );
                    } ).on( 'mouseleave mouseout', '.js-product-image-zoom-by-side-container', function ( event ) {
                        sika.ecom.carousel.zoom.style.reset( event.target );
                    } ).on( sika.ecom.carousel.zoom.scroll.wheelEvent, '.js-product-image-zoom-by-side-container', function ( event ) {

                        if ( jQuery( event.target ).is( '.js-product-image-zoom-by-side' ) ) {
                            return false;
                        }
                        if ( event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0 ) {
                            sika.ecom.carousel.zoom.level.set( sika.ecom.carousel.zoom.defaults.zoomStep );
                        }
                        else {
                            sika.ecom.carousel.zoom.level.set( -( sika.ecom.carousel.zoom.defaults.zoomStep ) );
                        }
                        sika.ecom.carousel.zoom.style.set( event.currentTarget, event );

                    } );
                },
                scroll: {
                    wheelEvent: ( function () {
                        return 'onwheel' in document.createElement( 'div' ) ? 'wheel' : 'mousewheel';
                    } )(),
                    wheelOpt: ( function () {
                        var supportsPassive = false;
                        try {
                            window.addEventListener( 'test', null, Object.defineProperty( {}, 'passive', {
                                get: function () { supportsPassive = true; }
                            } ) );
                        }
                        catch ( e ) {
                        }

                        return supportsPassive ? { passive: false } : false;
                    } )(),
                    disable: function () {
                        window.addEventListener( sika.ecom.carousel.zoom.scroll.wheelEvent, function ( event ) {
                            event.preventDefault();
                        }, sika.ecom.carousel.zoom.scroll.wheelOpt ); // modern desktop
                        window.addEventListener( 'touchmove', function ( event ) {
                            event.preventDefault();
                        }, sika.ecom.carousel.zoom.scroll.wheelOpt ); // mobile
                    },
                    enable: function () {
                        window.removeEventListener( sika.ecom.carousel.zoom.scroll.wheelEvent, function ( event ) {
                            event.preventDefault();
                        }, sika.ecom.carousel.zoom.scroll.wheelOpt );
                        window.removeEventListener( 'touchmove', function ( event ) {
                            event.preventDefault();
                        }, sika.ecom.carousel.zoom.scroll.wheelOpt );
                    }
                },
                level: {
                    get: function () {
                        var intZoomLevel = sika.ecom.carousel.zoom.defaults.zoomLevel;
                        if ( sika.ecom.carousel.zoom._zoomLevel ) {
                            intZoomLevel = sika.ecom.carousel.zoom._zoomLevel;
                        }
                        return intZoomLevel;
                    },
                    set: function ( intLevel ) {
                        var intCurrentLevel = sika.ecom.carousel.zoom.level.get(),
                            intNextLevel = intCurrentLevel + intLevel;
                        if ( intNextLevel > sika.ecom.carousel.zoom.defaults.maxZoomLevel ) {
                            intNextLevel = sika.ecom.carousel.zoom.defaults.maxZoomLevel;
                        }
                        else if ( intNextLevel < sika.ecom.carousel.zoom.defaults.minZoomLevel ) {
                            intNextLevel = sika.ecom.carousel.zoom.defaults.minZoomLevel;
                        }
                        sika.ecom.carousel.zoom._zoomLevel = intNextLevel;
                    }
                },
                style: {
                    get: function ( domElm, event ) {
                        var objBounds = domElm.getBoundingClientRect(),
                            jZoomLens = jQuery( '.js-img-zoom-lens' ),
                            intZoomLevel = sika.ecom.carousel.zoom.level.get(),
                            intPositionLeft = ( event.pageX - objBounds.left ) / ( objBounds.width ) * 100,
                            intPositionTop = ( event.pageY - objBounds.top ) / ( objBounds.height ) * 100;

                        var strPositionLeft = intPositionLeft + '%',
                            strPositionTop = intPositionTop + '%',
                            strSize = 100 * intZoomLevel + '%',
                            strCursor = 'all-scroll';

                        if ( intZoomLevel === sika.ecom.carousel.zoom.defaults.minZoomLevel ) {
                            strPositionLeft = 'cover';
                            strPositionTop = 'cover';
                            strSize = 'contain';
                            strCursor = 'zoom-in';
                        }

                        if ( jZoomLens.length ) {
                            jZoomLens.css( {
                                left: strPositionLeft,
                                top: strPositionTop
                            } );
                        }

                        return {
                            backgroundPositionX: strPositionLeft,
                            backgroundPositionY: strPositionTop,
                            backgroundSize: strSize,
                            backgroundRepeat: 'no-repeat',
                            cursor: strCursor
                        };

                    },
                    createLens: function ( domElm ) {
                        var lens = document.createElement( 'div' );
                        lens.className = 'img-zoom-lens js-img-zoom-lens';
                        domElm.parentElement.insertBefore( lens, domElm );
                    },
                    createSideView: function () {
                        var domContainer = document.createElement( 'div' );
                        domContainer.className = 'product-image-zoom-by-side-container js-product-image-zoom-by-side-container';
                        return domContainer;

                    },
                    set: function ( domElm, event ) {
                        if ( sika.ecom.carousel.zoom.zoomed === true ) {
                            var objZoomedStyle = sika.ecom.carousel.zoom.style.get( domElm, event ),
                                zoomType = jQuery( domElm ).is( '.js-product-image-zoom-by-side' ) ? 'byside' : 'inline',
                                domSideView = document.querySelector( '.js-product-image-zoom-by-side-container' );

                            sika.ecom.carousel.zoom.reference = domElm;

                            if ( zoomType === 'byside' && window.innerWidth > 799 ) {
                                if ( domSideView === null ) {
                                    var imageLargePath = domElm.dataset.src;
                                    objZoomedStyle.backgroundImage = 'url(' + imageLargePath + ')';
                                    domSideView = sika.ecom.carousel.zoom.style.createSideView();
                                    //sika.ecom.carousel.zoom.style.createLens( domElm );
                                    jQuery( domElm ).before( domSideView );
                                }
                                sika.ecom.carousel.zoom._zoomLevel = sika.ecom.carousel.zoom.defaults.maxZoomLevel;
                                sika.ecom.carousel.zoom.reference = domSideView;
                            }

                            jQuery( sika.ecom.carousel.zoom.reference ).css( objZoomedStyle );
                        }
                    },
                    reset: function ( domElm ) {
                        jQuery( '.js-product-image-zoom-by-side-container, .js-img-zoom-lens' ).remove();

                        sika.ecom.carousel.zoom.zoomed = false;

                        jQuery( domElm ).css( {
                            backgroundPositionX: '',
                            backgroundPositionY: '',
                            backgroundSize: '',
                            backgroundRepeat: '',
                            cursor: ''
                        } );
                        sika.ecom.carousel.zoom.reference = null;
                        sika.ecom.carousel.zoom._zoomLevel = sika.ecom.carousel.zoom.defaults.zoomLevel;
                    }
                }
            }
        },
        productlist: {
            hoverImage: {
                show: function ( domElm ) {
                    var jTarget = jQuery( domElm ).closest( '.js-e-products-item-image-wrapper' ).find( '.js-productlist-hover-image' );
                    jQuery( domElm ).addClass( 'd-none' );
                    jTarget.removeClass( 'd-none' );
                },
                hide: function ( domElm ) {
                    var jTarget = jQuery( domElm ).closest( '.js-e-products-item-image-wrapper' ).find( '.js-productlist-hover-image' );
                    jQuery( domElm ).removeClass( 'd-none' );
                    jTarget.addClass( 'd-none' );
                }
            }
        },
        variants: {
            init: function () {
                if ( jQuery( '.js-e-cc-list-product' ).length > 0 ) {
                    sika.ecom.variantMatrix.initForFavorite();
                }
                else if ( jQuery( '.js-sika-product-variants' ).length === 1 || jQuery( '.js-e-productdetails-variant-matrix-container' ).length === 1 || jQuery( '.js-sika-no-shop' ).length === 1 ) {
                    var prodId = '';
                    if ( jQuery( '.js-sika-no-shop' ).length === 1 ) {
                        prodId = jQuery( '.js-sika-no-shop' ).data( 'id' );
                    }
                    else if ( jQuery( '.js-sika-product-variants' ).length === 1 ) {
                        prodId = jQuery( '.js-sika-product-variants' ).data( 'id' );
                    }

                    sika.ecom.variants.load( prodId );
                }

            },
            load: function ( productId, fnCallback ) {
                jQuery.ajax( {
                    url: '/system/data/matrix',
                    data: {
                        productid: !productId ? jQuery( '.js-e-productdetails-variant-matrix-container' ).data( 'productId' ) : productId
                    },
                    dataType: 'JSON'
                } ).done( function ( data ) {
                    if ( typeof fnCallback === 'function' ) {
                        sika.ecom.variants.data = data;
                        fnCallback( data );
                    }
                    else {
                        sika.ecom.variants.data = sika.ecom.variants.handleData( data );
                        sika.ecom.variants.bindVariants( data );
                        /*
                         if ( sika.ecom.variants.data.hasAssortment === true ) {
                         sika.ecom.testAssortment( sika.ecom.variants.bindVariants );
                         }
                         else {
                         sika.ecom.variants.bindVariants();
                         }
                         */

                    }

                } );
            },
            bindVariants: function ( data ) {
                var matrixContainer = jQuery( '.js-e-productdetails-variant-matrix-container' );
                sika.ecom.variants.bindEvents();
                if ( matrixContainer.length > 0 ) {
                    sika.ecom.variantMatrix.init();
                }
                if ( jQuery( '.js-sika-no-shop' ).length > 0 ) {
                    sika.ecom.variants.filterVariants();
                }
                if ( jQuery( '.js-e-cc-list-product' ).length > 0 && data.variantcombinations.length ) {
                    var price = sika.ecom.variants.getPriceRange( data.variantcombinations );
                    matrixContainer.closest( '.js-e-cc-list-product' ).find( '.js-sika-b2b-top-price' ).html( e4.handlebars.tmpl.sikaB2bTopPrice( price ) );
                }
                sika.ecom.variants.build( sika.ecom.variants.data );
            },
            bindEvents: function () {
                jQuery( '.js-sika-product-variants-container' ).on( 'change', '.js-variant-select-Color', function ( event ) {
                    var jColorSelect = jQuery( event.target );
                    if ( jQuery( '.js-sika-matrix-modal' ).length === 0 ) {
                        sika.ecom.variants.filterAvaiableSizes( jColorSelect );
                    }

                } ).on( 'change', '.js-variant-select-Size', function () {
                    sika.ecom.variants.setFormFields();
                } ).on( 'click', '.js-color-option-selectable', function () {
                    var jSelectValue = jQuery( this ).data( 'value' ),
                        strSelectedColorcode = jQuery( this ).data( 'color' ).replace( 'C-', '' );
                    location.hash = strSelectedColorcode;
                    //history.replaceState(null, null, location.href.replace(location.hash, '#'+strSelectedColorcode));
                    sika.ecom.carousel.getData( strSelectedColorcode );
                    jQuery( this ).addClass( 'active' ).siblings( '.js-color-option-selectable' ).removeClass( 'active' );
                    //console.log("test");
                    jQuery( '.js-variant-select-Color' ).val( jSelectValue ).trigger( 'change' );
                } );
            },
            handleData: function ( data ) {
                if ( data.variantcombinations.length === 1 ) {
                    data.isSimple = true;
                }

                if ( data.variantoptions.Size !== undefined ) {
                    data.variantoptions.Size = data.variantoptions.Size.sort( function ( a, b ) {
                        var sizeA = parseInt( a.name ),
                            sizeB = parseInt( b.name );
                        return sizeA - sizeB;

                    } );
                }

                return data;
            },
            filterAvaiableSizes: function ( jColorSelect ) {
                jColorSelect = jColorSelect || jQuery( '.js-variant-select-Color' );

                var variantColorID = jColorSelect.val(),
                    availableCombos = sika.ecom.variants.data.variantcombinations.length > 0 ? sika.ecom.variants.data.variantcombinations.filter( function ( obj ) {
                        return obj.variantID.indexOf( variantColorID ) > -1;
                    } ) : [],
                    availableSizes = [];
                for ( var i in availableCombos ) {
                    if ( availableCombos[ i ].productActive === true && availableCombos[ i ].productStock > 0 ) {
                        availableSizes.push( availableCombos[ i ].variantID.split( '.' )[ 1 ] );
                    }
                }

                if ( sika.ecom.variants.data.isSimple === false ) {
                    jQuery( '.js-variant-select-Size' ).find( 'option' ).each( function () {
                        var jOption = jQuery( this ),
                            sizeOptionID = jOption.val();

                        if ( jQuery.inArray( sizeOptionID, availableSizes ) === -1 ) {

                            if ( jOption.prop( 'selected' ) === true ) {
                                jOption.prop( 'selected', false );
                            }
                            jOption.prop( 'disabled', true );
                            jOption.hide();
                        }
                        else {
                            jOption.show();
                            jOption.prop( 'disabled', false );
                        }
                    } );
                    sika.ecom.variants.setFormFields();
                }

            },
            setFormFields: function () {
                var colorVariantID = jQuery( '.js-variant-select-Color' ).val(),
                    sizeVariantID = jQuery( '.js-variant-select-Size' ).val();
                if ( colorVariantID !== undefined && sizeVariantID !== undefined ) {
                    var variantCombo = colorVariantID + '.' + sizeVariantID;

                    jQuery( '.js-e-product-form-addtocart' ).find( 'input[name="VariantID"]' ).val( variantCombo );
                    sika.ecom.variants.setDetails( variantCombo );
                }

            },
            setDetails: function ( selectedVariantComboID ) {
                var jProductContainer = jQuery( '.js-sika-product-variants' );
                if ( sika.ecom.variants.data.variantcombinations.length > 0 ) {
                    sika.ecom.variants.data.variantcombinations.filter( function ( obj ) {
                        if ( obj.variantID === selectedVariantComboID ) {
                            jQuery.each( obj, function ( key ) {
                                jProductContainer.find( '[data-set-html="' + key + '"]' ).hide().html( obj[ key ] ).fadeIn( 'fast' );
                                //jProductContainer.find('[data-set-text="'+key+'"]').hide().text(obj[key]).fadeIn('fast');
                                //jProductContainer.find('[data-set-src="'+key+'"]').attr('src', obj[key]);
                                if ( obj.productBeforePriceClean > obj.productPriceClean ) {
                                    jQuery( '.e-product-price-before, .sika-product-price-pct' ).removeClass( 'd-none' );
                                }
                                else {
                                    jQuery( '.e-product-price-before, .sika-product-price-pct' ).addClass( 'd-none' );
                                }
                            } );
                        }
                    } );
                }
            },
            getFilteredVariants: function ( jsonData ) {
                var returnValue = jsonData;

                if ( returnValue.variantoptions.Color !== undefined ) {
                    for ( var c = 0; c < returnValue.variantoptions.Color.length; c++ ) {
                        returnValue.variantoptions.Color[ c ].sizes = [];
                        if ( returnValue.variantcombinations.length ) {
                            returnValue.variantoptions.Color[ c ].isAllowed = returnValue.variantcombinations.filter( function ( obj ) {
                                return obj.variantID.indexOf( returnValue.variantoptions.Color[ c ].id ) > -1;
                            } ).length > 0;
                        }

                        returnValue.variantoptions.Color[ c ].hasIndicativePrice = returnValue.hasIndicativePrice;
                        if ( returnValue.variantoptions.Size !== undefined ) {
                            for ( var s = 0; s < returnValue.variantoptions.Size.length; s++ ) {
                                var strVariantId = [ returnValue.variantoptions.Color[ c ].value, returnValue.variantoptions.Size[ s ].value ].join( '.' );
                                for ( var vc = 0; vc < returnValue.variantcombinations.length; vc++ ) {
                                    if ( returnValue.variantcombinations[ vc ].variantID === strVariantId ) {
                                        returnValue.variantoptions.Color[ c ].statusGroup = returnValue.variantcombinations[ vc ].statusGroup;

                                        returnValue.variantoptions.Size[ s ].hasEAN = returnValue.variantcombinations[ vc ].productEAN !== '';

                                        returnValue.variantoptions.Color[ c ].sizes.push( {
                                            name: returnValue.variantoptions.Size[ s ].name,
                                            value: returnValue.variantoptions.Size[ s ].value,
                                            combo: returnValue.variantcombinations[ vc ]
                                        } );
                                        break;
                                    }
                                }
                            }
                        }
                        else {
                            var strVariantId = returnValue.variantoptions.Color[ c ].value;
                            for ( var vc = 0; vc < returnValue.variantcombinations.length; vc++ ) {
                                if ( returnValue.variantcombinations[ vc ].variantID === strVariantId ) {
                                    returnValue.variantoptions.Color[ c ].sizes.push( {
                                        name: 'One-size',
                                        value: '',
                                        combo: returnValue.variantcombinations[ vc ]
                                    } );
                                    break;
                                }
                            }
                        }
                    }
                }

                return returnValue;

            },
            filterVariants: function () {
                if ( sika.ecom.variants.data.variantoptions.Color !== undefined ) {
                    for ( var c = 0; c < sika.ecom.variants.data.variantoptions.Color.length; c++ ) {
                        sika.ecom.variants.data.variantoptions.Color[ c ].sizes = [];
                        if ( sika.ecom.variants.data.variantcombinations.length ) {
                            sika.ecom.variants.data.variantoptions.Color[ c ].isAllowed = sika.ecom.variants.data.variantcombinations.filter( function ( obj ) {
                                return obj.variantID.indexOf( sika.ecom.variants.data.variantoptions.Color[ c ].id ) > -1;
                            } ).length > 0;
                        }

                        var image = jQuery( '.js-e-product-image-carousel-inner' ).find( '.carousel-item[data-color="' + sika.ecom.variants.data.variantoptions.Color[ c ].img.replace( 'C-', '' ) + '"]' );
                        var large = jQuery( '.js-e-product-image-modal' ).find( '.carousel-item[data-color="' + sika.ecom.variants.data.variantoptions.Color[ c ].img.replace( 'C-', '' ) + '"]' );
                        var thumb = jQuery( '.js-e-product-image-modal' ).find( '.carousel-indicator-item[data-color="' + sika.ecom.variants.data.variantoptions.Color[ c ].img.replace( 'C-', '' ) + '"]' );
                        if ( sika.ecom.variants.data.variantoptions.Color[ c ].isAllowed === false ) {
                            image.remove();
                            large.remove();
                            thumb.remove();
                        }
                        sika.ecom.variants.data.variantoptions.Color[ c ].hasIndicativePrice = sika.ecom.variants.data.hasIndicativePrice;
                        if ( sika.ecom.variants.data.variantoptions.Size !== undefined ) {
                            for ( var s = 0; s < sika.ecom.variants.data.variantoptions.Size.length; s++ ) {
                                var strVariantId = [ sika.ecom.variants.data.variantoptions.Color[ c ].value, sika.ecom.variants.data.variantoptions.Size[ s ].value ].join( '.' );
                                for ( var vc = 0; vc < sika.ecom.variants.data.variantcombinations.length; vc++ ) {
                                    if ( sika.ecom.variants.data.variantcombinations[ vc ].variantID === strVariantId ) {
                                        sika.ecom.variants.data.variantoptions.Color[ c ].statusGroup = sika.ecom.variants.data.variantcombinations[ vc ].statusGroup;

                                        sika.ecom.variants.data.variantoptions.Size[ s ].hasEAN = sika.ecom.variants.data.variantcombinations[ vc ].productEAN !== '';

                                        sika.ecom.variants.data.variantoptions.Color[ c ].sizes.push( {
                                            name: sika.ecom.variants.data.variantoptions.Size[ s ].name,
                                            value: sika.ecom.variants.data.variantoptions.Size[ s ].value,
                                            combo: sika.ecom.variants.data.variantcombinations[ vc ]
                                        } );
                                        break;
                                    }
                                }
                            }
                        }
                        else {
                            var strVariantId = sika.ecom.variants.data.variantoptions.Color[ c ].value;
                            for ( var vc = 0; vc < sika.ecom.variants.data.variantcombinations.length; vc++ ) {
                                if ( sika.ecom.variants.data.variantcombinations[ vc ].variantID === strVariantId ) {
                                    sika.ecom.variants.data.variantoptions.Color[ c ].sizes.push( {
                                        name: 'One-size',
                                        value: '',
                                        combo: sika.ecom.variants.data.variantcombinations[ vc ]
                                    } );
                                    break;
                                }
                            }
                        }
                    }
                }

                var allowedColorsArr = sika.ecom.variants.data.variantoptions.Color.filter( function ( color ) {
                    return color.isAllowed == true;
                } );

                if ( allowedColorsArr.length > 1 ) {
                    jQuery( '.js-toggle-download-product-images' ).attr( 'href', '#' );
                }
                else if ( allowedColorsArr.length === 1 ) {
                    //jQuery( '.js-toggle-download-product-images' ).attr( 'href', '/Admin/Public/Download.aspx?File=' + allowedColorsArr[ 0 ].downloadUrl );
                }

                if ( jQuery( '.js-sika-product-variant-image-list-download-image' ).length === 1 ) {
                    jQuery( '.js-sika-product-variant-image-list-download-image' ).html( e4.handlebars.tmpl.sikaProductVariantImageListDownloadImage( sika.ecom.variants.data ) );
                }
                if ( jQuery( '.js-sika-product-variant-image-list-client-logo' ).length === 1 ) {
                    jQuery( '.js-sika-product-variant-image-list-client-logo' ).html( e4.handlebars.tmpl.sikaProductVariantImageListClientLogo( sika.ecom.variants.data ) );
                }
                if ( jQuery( '.js-sika-product-variant-image-list-download' ).length > 0 ) {
                    jQuery( '.js-sika-product-variant-image-list-download' ).html( e4.handlebars.tmpl.sikaProductVariantImageListDownload( sika.ecom.variants.data ) );
                }
            },
            build: function ( data ) {
                if ( jQuery( '.js-sika-product-variants-container' ).length === 1 ) {
                    jQuery( '.js-sika-product-variants-container' ).html( e4.handlebars.tmpl.sikaProductVariantsOptions( data ) );
                }

                sika.ecom.setVariantColor();
                sika.ecom.variants.filterAvaiableSizes();
                e4.loading.resolveWait( '.js-sika-product-variants' );

                if ( jQuery( '.js-sika-b2b-top-price' ).length === 1 && data.variantcombinations.length ) {
                    var price = sika.ecom.variants.getPriceRange( data.variantcombinations );
                    jQuery( '.js-sika-b2b-top-price' ).html( e4.handlebars.tmpl.sikaB2bTopPrice( price ) );
                }

            },
            getPriceRange: function ( combos ) {
                var pricesArr = combos.map( function ( obj ) {
                        return {
                            clean: obj.productPriceClean,
                            formatted: obj.productPrice
                        };

                    } ),
                    sortedPricesArr = pricesArr.slice().sort( function ( a, b ) {
                        return a.clean - b.clean;
                    } ),
                    smallestPrice = 0,
                    largestPrice = sortedPricesArr[ sortedPricesArr.length - 1 ].clean;
                for ( var i = 0; i < sortedPricesArr.length; i++ ) {
                    if ( sortedPricesArr[ i ].clean > 0 ) {
                        smallestPrice = sortedPricesArr[ i ];
                        break;
                    }
                }
                return {
                    fromPrice: smallestPrice.clean === largestPrice ? false : true,
                    price: smallestPrice.formatted
                };
            }
        },
        variantMatrix: {
            init: function () {
                sika.ecom.variantMatrix.bindEvents();
                sika.ecom.variantMatrix.buildMatrixData();
            },
            bindEvents: function ( favoritesMatrixContainer ) {
                var matrixContainer = favoritesMatrixContainer || jQuery( '.js-e-productdetails-variant-matrix-container' );
                matrixContainer.on( 'input', '.js-variant-matrix-quantity', function () {
                    sika.ecom.variantMatrix.updatePrice(matrixContainer);
                    sika.ecom.variantMatrix.updateQuantity(matrixContainer);
                    var hasQuantityOverLimit = sika.ecom.variantMatrix.hasQuantityOverLimit(matrixContainer);
                    var hasQuantityUnderLimit = sika.ecom.variantMatrix.hasQuantityUnderLimit(matrixContainer);
                    if ( hasQuantityOverLimit.length > 0 ) {
                        //sika.ecom.variantMatrix.status.setDisabled( hasQuantityOverLimit );  
                    }
                    else {
                        jQuery( '.js-sika-variant-matrix-submit' ).prop( 'disabled', false );
                    }
                } ).on( 'focus', '.js-variant-matrix-quantity', function () {
                    jQuery( this ).closest( '.js-variant-matrix-row' ).addClass( 'variant-matrix-row--current' )
                } ).on( 'blur', '.js-variant-matrix-quantity', function () {
                    jQuery( this ).closest( '.js-variant-matrix-row' ).removeClass( 'variant-matrix-row--current' )
                } );

                jQuery( document ).on( 'productadded.e4.cart', function () {
                    jQuery( '.js-e-product-form-addtocart' ).trigger( 'reset' );
                } );
            },
            favoritesContainer: '',
            favoriteMatrixes: {},
            initForFavorite: function () {
                var xhrQueue = [];
                jQuery( '.js-e-productdetails-variant-matrix-container' ).each( function ( index, domElm ) {
                    var prodId = jQuery( domElm ).data( 'productId' );
                    sika.ecom.variantMatrix.favoriteMatrixes[ prodId ] = {
                        loaded: false,
                        xhr: sika.ecom.variantMatrix.loadForFavorite( prodId ),
                        container: jQuery( domElm ),
                        data: null
                    };

                    xhrQueue.push( sika.ecom.variantMatrix.favoriteMatrixes[ prodId ].xhr );

                    sika.ecom.variantMatrix.favoriteMatrixes[ prodId ].xhr.done( function ( jsonData ) {
                        sika.ecom.variantMatrix.favoriteMatrixes[ prodId ].data = jsonData;
                        var matrixContainer = jQuery( domElm ),
                            filteredData = sika.ecom.variants.getFilteredVariants( jsonData );

                        var filteredMatrixColorArr = filteredData.variantoptions.Color.filter( function ( obj ) {
                            return obj.isAllowed === true;
                        } );

                        matrixContainer.html( e4.handlebars.tmpl.sikaVariantMatrix( filteredMatrixColorArr ) );

                        sika.ecom.variantMatrix.bindEvents( matrixContainer );

                        if ( jQuery( '.js-e-cc-list-product' ).length > 0 && filteredData.variantcombinations.length ) {
                            var price = sika.ecom.variants.getPriceRange( filteredData.variantcombinations );
                            matrixContainer.closest( '.js-e-cc-list-product' ).find( '.js-sika-b2b-top-price' ).html( e4.handlebars.tmpl.sikaB2bTopPrice( price ) );
                        }

                        sika.ecom.variantMatrix.favoriteMatrixes[ prodId ].loaded = true;
                    } )
                } );

                jQuery.when.apply( this, xhrQueue ).then( function () {
                    jQuery( '[data-toggle="tooltip"]' ).tooltip( {
                        container: 'body'
                    } );

                } );

                //var firstMatrix = jQuery( '.js-e-productdetails-variant-matrix-container' ).first().data( 'productId' );
                //sika.ecom.variantMatrix.loadForFavorite( firstMatrix );
            },
            loadForFavorite: function ( prodId ) {
                //sika.ecom.variantMatrix.favoritesContainer = jQuery( '.js-e-productdetails-variant-matrix-container[data-product-id="' + prodId + '"]' );
                return jQuery.ajax( {
                    url: '/system/data/matrix',
                    data: {
                        productid: prodId
                    },
                    dataType: 'JSON'
                } );
            },
            setupForFavorites: function ( data ) {
                sika.ecom.variants.data = sika.ecom.variants.handleData( data );

                if ( sika.ecom.variants.data.hasAssortment === true ) {
                    sika.ecom.testAssortment( sika.ecom.variants.bindVariants );
                }
                else {
                    sika.ecom.variants.bindVariants( data );
                }
            },
            buildMatrixData: function () {

                sika.ecom.variants.filterVariants();

                if ( sika.ecom.variants.data.variantcombinations.length ) {
                    jQuery( '.js-e-product-cc-list-form' ).find( '.js-e-cc-list' ).each( function () {
                        var addUrl = jQuery( this ).data( 'url-add' ),
                            removeUrl = jQuery( this ).data( 'url-remove' ),
                            newAddUrl = addUrl.replace( /(CCAddToListVariantID=).*?(&)/, '$1' + sika.ecom.variants.data.variantcombinations[ 0 ].variantID + '$2' ),
                            newRemoveUrl = removeUrl.replace( /(CCAddToListVariantID=).*?(&)/, '$1' + sika.ecom.variants.data.variantcombinations[ 0 ].variantID + '$2' );
                        jQuery( this ).data( 'url-add', newAddUrl );
                        jQuery( this ).data( 'url-remove', newRemoveUrl );
                    } );
                }

                var filteredMatrixColorArr = sika.ecom.variants.data.variantoptions.Color.filter( function ( obj ) {
                    return obj.isAllowed === true;
                } );

                sika.ecom.variantMatrix.build( filteredMatrixColorArr );
            },
            build: function ( arrVariantMatrixCombos ) {
                var matrixContainer = jQuery( '.js-e-productdetails-variant-matrix-container' );
                matrixContainer.html( e4.handlebars.tmpl.sikaVariantMatrix( arrVariantMatrixCombos ) );
                jQuery( '[data-toggle="tooltip"]' ).tooltip( {
                    container: 'body'
                } );

                //jQuery( '.js-sika-product-variants' ).trigger( 'sika.favorite-matrix.loaded', [ matrixContainer.data( 'productId' ) ] );
            },
            status: {
                setDisabled: function ( domElems ) {
                    for ( var i = 0; i < domElems.length; i++ ) {
                        jQuery( domElems[ i ] ).addClass( 'variant-matrix-row--danger' );
                    }
                    jQuery( '.js-sika-variant-matrix-submit' ).prop( 'disabled', true );
                }
            },
            hasQuantityOverLimit: function (favoriteMatrixContainer) {
                var matrixContainer = favoriteMatrixContainer || jQuery( '.js-e-productdetails-variant-matrix-container' );
                var overQuantity = matrixContainer.find( '.js-variant-matrix-row' ).filter( function () {
                    var quantityInput = jQuery( this ).find( '.js-variant-matrix-quantity' ),
                        intQuantity = parseInt( quantityInput.val() ),
                        intInStock = parseInt( quantityInput.data( 'stock' ) );
                    /*
                     if(isNaN(intQuantity) === false) {
                     if ( intQuantity > intInStock || intInStock === 0 && intQuantity === 0) {
                     jQuery( this ).addClass( 'variant-matrix-row--danger' );
                     return this;
                     }
                     else {
                     jQuery( this ).removeClass( 'variant-matrix-row--danger' );
                     }
                     }
                     console.log(intQuantity);
                     */

                } );
                return overQuantity;
            },
            hasQuantityUnderLimit: function (favoriteMatrixContainer) {
                var matrixContainer = favoriteMatrixContainer || jQuery( '.js-e-productdetails-variant-matrix-container' );
                var underQuantity = matrixContainer.find( '.js-variant-matrix-row' ).filter( function () {
                    var quantityInput = jQuery( this ).find( '.js-variant-matrix-quantity' ),
                        intQuantity = parseInt( quantityInput.val() ),
                        intInStock = parseInt( quantityInput.data( 'stock' ) );
                    if ( intQuantity <= intInStock ) {
                        jQuery( this ).addClass( 'variant-matrix-row--added' );
                        return this;
                    }
                    else {
                        jQuery( this ).removeClass( 'variant-matrix-row--added' );
                    }

                } );
                return underQuantity;
            },
            updateQuantity: function (favoriteMatrixContainer) {
                var matrixContainer = favoriteMatrixContainer || jQuery( '.js-e-productdetails-variant-matrix-container' );
                var rowQuantity = 0;
                var quantityTotal = 0;
                matrixContainer.find( '.js-variant-panel' ).each( function () {
                    var jPanel = jQuery( this );
                    rowQuantity = 0;
                    jPanel.find( '.js-variant-matrix-quantity' ).each( function () {
                        rowQuantity += parseInt( ( jQuery( this ).val() ? jQuery( this ).val() : 0 ) );
                    } );
                    jPanel.find( '.js-variant-matrix-header-quantity' ).html( rowQuantity );
                    quantityTotal += rowQuantity;
                } );
                if ( quantityTotal > 0 ) {
                    jQuery( '.js-sika-variant-matrix-hide-elements-until-quantity' ).removeClass( 'sika-variant-matrix-hide-elements-until-quantity' );
                }
                else {
                    jQuery( '.js-sika-variant-matrix-hide-elements-until-quantity' ).addClass( 'sika-variant-matrix-hide-elements-until-quantity' );
                }
            },
            updatePrice: function (favoriteMatrixContainer) {
                var matrixContainer = favoriteMatrixContainer || jQuery( '.js-e-productdetails-variant-matrix-container' );
                var jAccordion = matrixContainer,
                    totalPrice = 0;
                jAccordion.find( '.js-variant-matrix-quantity' ).each( function () {
                    var price = jQuery( this ).data( 'price' ),
                        quantity = jQuery( this ).val();
                    if ( typeof price === 'string' ) {
                        price = e4.util.formatStringToJavascriptNumber( price );
                    }
                    if ( typeof quantity === 'string' ) {
                        if ( quantity === '' ) {
                            quantity = '0';
                        }
                        quantity = parseInt( quantity );
                    }
                    totalPrice += price * ( quantity ? quantity : 0 );
                } );
                var formattedTotalPrice = e4.util.formatJavascriptNumberToLocaleString( totalPrice ),
                    priceElm = matrixContainer.find( '.js-matrix-total-price' );
                priceElm.data( 'total', totalPrice ).find( '.js-price-container' ).text( formattedTotalPrice );
            }
        },
        setVariantColor: function () {
            if ( jQuery( '.js-e-product' ).length === 1 ) {
                var variantColor = 0;
                if ( location.hash.length > 0 ) {
                    variantColor = parseInt( location.hash.replace( '#', '' ) );
                }
                else {
                    variantColor = sika.ecom.variants.data.variantoptions.Color.filter( function ( obj ) {
                        return obj.isAllowed === true;
                    } )[ 0 ].img.replace( 'C-', '' );
                }
                if ( isNaN( parseInt( variantColor ) ) === false ) {
                    jQuery( '#js-e-product-image-carousel' ).find( '.carousel-item' ).each( function () {
                        if ( parseInt( jQuery( this ).data( 'color' ) ) === parseInt( variantColor ) ) {
                            jQuery( this ).siblings().removeClass( 'active' );
                            jQuery( this ).addClass( 'active' );
                        }
                    } );
                    if ( jQuery( '.js-color-option-selectable' ).length > 0 ) {
                        jQuery( '.js-color-option-selectable[data-color="C-' + parseInt( variantColor ) + '"]' ).trigger( 'click' );
                    }
                }
            }
            jQuery( '.js-e-product-image-carousel-inner ' ).removeClass( 'd-none' );
        }
    };
}() );
